const EARTH_RADIUS_KM = 6371;

const toRadians = (degrees) => (Number(degrees) * Math.PI) / 180;

export const haversineDistanceKm = (lat1, lng1, lat2, lng2) => {
  const lat1N = Number(lat1);
  const lng1N = Number(lng1);
  const lat2N = Number(lat2);
  const lng2N = Number(lng2);

  if (
    !Number.isFinite(lat1N) ||
    !Number.isFinite(lng1N) ||
    !Number.isFinite(lat2N) ||
    !Number.isFinite(lng2N)
  ) {
    return NaN;
  }

  const dLat = toRadians(lat2N - lat1N);
  const dLng = toRadians(lng2N - lng1N);
  const lat1Rad = toRadians(lat1N);
  const lat2Rad = toRadians(lat2N);

  const sinDLat = Math.sin(dLat / 2);
  const sinDLng = Math.sin(dLng / 2);
  const a =
    sinDLat * sinDLat +
    Math.cos(lat1Rad) * Math.cos(lat2Rad) * sinDLng * sinDLng;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_KM * c;
};
